import * as React from "react";
import { _MasterDetailView, } from "../../generic/master-detail-view/MasterDetailView";
import { DetailViewCoopProjects } from "./DetailViewCoopProjects";
import { MasterViewCoopProjects } from "./MasterViewCoopProjects";
export var MasterDetailCoopProjects = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewCoopProjects, detailRenderer: DetailViewCoopProjects }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/MasterDetailCoopProjects.tsx
// module id = 2588
// module chunks = 3